module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "glyphicon glyphicon-earphone voip-alert",
    class: _vm.css_class,
    on: {
      "click": function($event) {
        return _vm.openDialer(null, "", null, false)
      }
    }
  }, [_c('alert-tick', {
    attrs: {
      "service_status": _vm.voip_status,
      "message": _vm.voip_message
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58424cc6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/header_actions/voip.vue
// module id = 1131
// module chunks = 1